import {SelectionModel} from '@angular/cdk/collections';
import {AfterViewInit, Component, ElementRef, Inject, NgZone, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatStepper} from '@angular/material/stepper';
import {MatTableDataSource} from '@angular/material/table';
import QuillBetterTable from 'quill-better-table';
import {SenderInfo} from '../../../../models/SenderInfo';
import {Student} from '../../../../models/student';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import * as Quill from 'quill';
import {quillConfig, tableImage} from '../../../shared/text-editor/quillConfig';
import {FileService} from 'src/app/services/file.service';
import {HttpClient} from '@angular/common/http';
import {io, Socket} from 'socket.io-client';
import {Observable} from 'rxjs';
import {environment} from '../../../../../environments/environment';
// import {quillConfig, tableImage } from '../../../shared/text-editor/quillConfig';


declare let QuillToolbarButton: any;

@Component({
    selector: 'app-form-assignment',
    templateUrl: './form-assignment.component.html',
    styleUrls: ['./form-assignment.component.scss']
})
export class FormAssignmentComponent implements OnInit {
    //#region class members
    @ViewChild('stepper', {static: false}) stepper: MatStepper;
    affirmations: MatTableDataSource<any>;
    announcements: MatTableDataSource<any>;
    childId: number;
    consents: MatTableDataSource<any>;
    customForms: MatTableDataSource<any>;
    displayColumns = ['select', 'title', 'date_created', 'created_by'];
    editorStyle: any;
    forms: MatTableDataSource<any>;
    formsLoading = false;
    isLinear = true;
    isLoading = false;
    isNotificationLoading: boolean;
    isRequestLoading: boolean;
    loading: boolean;
    message: string;
    notifyParents: any;
    parentId: number;
    public selection: SelectionModel<any>;
    searchValue: string;
    selectedAffirmations: SelectionModel<any>;
    selectedAnnouncements: SelectionModel<any>;
    selectedConsents: SelectionModel<any>;
    selectedCustomForms: SelectionModel<any>;
    selectedSender: SenderInfo;
    senderAddress = '';
    senderName = '';
    senders: SenderInfo[] = [];
    students: Student[];
    subject = '';
    tempForms = [];
    publishToParents: false;
    bothParents: false;
    //#endregion
    @ViewChild('editable', {static: true}) editor: ElementRef;
    quill: any;
    table: any;
    emailSendLoading: boolean;
    showAttachmentLimit = false;
    public files: any = [];

    private socket: Socket;
    private user: any;

    //#region Constructor and OnInit
    constructor(private commonService: CommonService,
                public confirmDialog: MatDialog,
                private zone: NgZone,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public fileService: FileService,
                public httpClient: HttpClient,
                public toastMessagesService: ToastMessagesService, public dialog: MatDialogRef<FormAssignmentComponent>) {
        this.parentId = data.parentId;
        this.childId = data.childId;
        this.searchValue = '';
        this.selection = new SelectionModel<any>(true, []);
        this.editorStyle = {width: '100%', height: '400px'};
        this.message = '';
        this.isNotificationLoading = false;
        this.students = data.students;
        this.loading = false;
        this.isRequestLoading = false;
        this.emailSendLoading = false;
        this.socket = io(environment.apiUrl.split('api')[0]);
        this.user = JSON.parse(localStorage.getItem('user'));
    }

    async ngOnInit() {
        try {
            this.formsLoading = true;
            this.notifyParents = true;
            await this.initializeForms();
            await this.initializeCustomForms();
            await this.initSenders();

            this.onMailSent().subscribe((event: any) => {
              if (event.show_snackbar) {
                this.toastMessagesService.toastMessages(`Η ειδοποίηση στάλθηκε με επιτυχία`);
              }
            });
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(`${e.message}`);
        } finally {
            this.formsLoading = false;
        }
    }

    initQuill() {
        Quill.register({
            'modules/better-table': QuillBetterTable
        }, true);
        const containerEditor = document.querySelector('#quill-editor');
        this.quill = new Quill(containerEditor, {
            theme: 'snow',
            debug: 'info',
            bounds: '#quil-editor',
            modules: {
                table: false,
                'better-table': {
                    operationMenu: {
                        items: {
                            unmergeCells: {
                                text: 'Another unmerge cells name'
                            }
                        }
                    }
                },
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{header: 1}, {header: 2}],               // custom button values
                    [{list: 'ordered'}, {list: 'bullet'}],
                    [{script: 'sub'}, {script: 'super'}],      // superscript/subscript
                    [{indent: '-1'}, {indent: '+1'}],          // outdent/indent
                    [{direction: 'rtl'}],                         // text direction

                    [{size: ['small', false, 'large', 'huge']}],  // custom dropdown
                    [{header: [1, 2, 3, 4, 5, 6, false]}],

                    [{color: []}, {background: []}],          // dropdown with defaults from theme
                    [{font: []}],
                    [{align: []}],

                    ['clean'],                                         // remove formatting button
                    ['link', 'image'],
                ],
                keyboard: {
                    bindings: QuillBetterTable.keyboardBindings
                }
            }
        });
        this.quill.bounds = containerEditor;

        this.table = this.quill.getModule('better-table');
        this.initializeExtraToolbarIcons();
        this.initQuillEvents();
    }

    initQuillEvents(): void {
        this.quill.on('text-change', () => {
            this.message = this.quill.root.innerHTML;
            // this.editorOutputContent.emit(this.quill.root.innerHTML);
        });
    }

    initializeExtraToolbarIcons(): void {
        const tableToolbarButton = new QuillToolbarButton({
            icon: tableImage,
            label: 'Δημιουργία πίνακα'
        });

        tableToolbarButton.onClick = () => { this.table.insertTable(3, 3); };
        tableToolbarButton.attach(this.quill);
    }


    //#endregion

//#region async requests
    async initSenders() {
        try {
            const request = await this.commonService.getList('college/email-senders');
            this.senders = request.object;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e);
            throw e;
        }
    }

    async initializeCustomForms() {
        try {
            const formsRequest = await this.commonService.getList('forms/custom');
            for (const object of formsRequest.object) {
                object.has_two_factor = object.has_two_factor ? object.isGDPR === 1 ? 'NAI' : 'OXI' : 'ΟΧΙ';
            }
            this.forms = new MatTableDataSource<any>(formsRequest.object);

            this.consents = new MatTableDataSource<any>(formsRequest.object.filter(form => form.form_type_id === 1));
            this.affirmations = new MatTableDataSource<any>(formsRequest.object.filter(form => form.form_type_id === 2));
            // this.customForms = new MatTableDataSource<any>(formsRequest.object);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τις προσαρμοσμένες δηλώσεις');
            throw e;
        }
    }

    async initializeForms() {
        try {
            const formsRequest = await this.commonService.getList('forms/forms');
            // this.forms = new MatTableDataSource<any>(formsRequest.object);
            // console.log(formsRequest.object);
            // this.consents = new MatTableDataSource<any>(formsRequest.object.filter(form => form.form_type_id === 1));
            // this.affirmations =  new MatTableDataSource<any>(formsRequest.object.filter(form => form.form_type_id === 2));
            this.announcements = new MatTableDataSource<any>(formsRequest.object.filter(form => form.form_type_id === 3));
            this.tempForms = formsRequest.object;
        } catch (e) {
            console.log(e.message);
            throw e;
        }
    }

    async sendNotification() {

        const notificationsList = [];

        for (const student of this.students) {
            for (const form of this.selection.selected) {
                console.log(form);
                const notificationModel = {
                    father_id: student.fatherId,
                    mother_id: student.motherId,
                    child_id: student.id,
                    consent_form_id: form.id,
                    form_unique_id: form.unique_id,
                    form_type_id: form.form_type_id,
                    mode: form.form_type_id === 3 ? 'display' : form.form_type_id === 2 ? 'affirmation' : 'consent',
                };
                notificationsList.push(notificationModel);
            }
        }
        const style = `<style>table,tr,th,td {border: 1px solid black;}</style>`;

        const insertModel = {
            notifications: notificationsList,
            message: `${style}${this.message}`,
            parentMustFill: this.publishToParents,
            bothParents: this.bothParents,
            sender: {
                address: this.selectedSender.address,
                name: this.selectedSender.name
            },
            subject: this.subject
        };


        const confirm = this.confirmDialog.open(ConfirmDialogComponent, {
            data: {
                title: `Δημοσίευση δηλώσεων`,
                message: `Είστε σίγουροι ότι θέλετε να δημοσιεύσετε τις επιλεγμένες δηλώσεις?`
            }
        });

        confirm.afterClosed().subscribe(async (result) => {
            if (result) {
                this.dialog.updateSize('300px', '100px');
                this.dialog.updatePosition({bottom: '50px', left: '25px'});
                this.isRequestLoading = true;
                this.isNotificationLoading = true;
                this.isLoading = true;
                try {
                  if (this.files.length > 0) {
                    const attachmentId = await this.uploadFiles(this.files);
                    this.commonService.insertItem('people/parents/notifications', {
                      ...insertModel,
                      uniqueId: attachmentId
                    });
                  } else {
                    await this.commonService.insertItem('people/parents/notifications', insertModel);
                  }
                  // this.toastMessagesService.toastMessages(`Η ειδοποίηση στάλθηκε με επιτυχία`);
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage(e.message);
                } finally {
                    this.isLoading = false;
                    this.isNotificationLoading = false;
                    this.dialog.close();
                    this.isRequestLoading = false;
                }
            }
        });

    }
    public onMailSent() {
      return new Observable(observer => {
        this.socket.on('email', (event) => {
          if (event.email === this.user.email) {
            observer.next(event);
          }
        });
      });
    }

    //#endregion
    public async uploadFiles(files) {
        try {
          const fileFormData = new FormData();
          for (const file of files) {
            const blobFile = file;
            fileFormData.append('file', blobFile, blobFile.name);
          }
          return new Promise((resolve, reject) => {
            this.httpClient.post(`people/parents/notifications/attachments`, fileFormData).subscribe((response: any) => {
              resolve(response.uniqueId);
            }, async (error) => {
                console.log(error);
                reject({status: error.status, message: error.message, serverMessage: error.error.message});
            });
          });
        } catch (error) {
          throw error;
        }
    }

    searchForms(value) {
        this.forms.filter = value.trim().toLowerCase();
    }

    searchConsents(value) {
        this.consents.filter = value.trim().toLowerCase();
    }

    searchAffirmations(value) {
        this.affirmations.filter = value.trim().toLowerCase();
    }

    searchCustomForms(value) {
        console.log(value);
        this.customForms.filter = value.trim().toLowerCase();
    }

    searchAnnouncements(value) {
        this.announcements.filter = value.trim().toLowerCase();
    }


    //#region checkboxes in table
    public isAllSelected(): boolean {
        const numSelected = this.selection.selected.length;

        // @ts-ignore
        const numRows = this.forms.data.length;

        return numSelected === numRows;
    }

    public masterToggle(): void {
        // @ts-ignore
        this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    //#endregion

    //#region Stepper previous & next
    async next() {
        if (this.stepper.selectedIndex === 0) {
            if (this.notifyParents) {
                this.stepper.next();
                // this.initQuill();
            } else {
                await this.sendNotification();
            }
        } else if (this.stepper.selectedIndex === 1) {
            // this.stepper.next();
            await this.sendNotification();
        }
    }

    previous() {
        this.stepper.previous();
    }

    proceedStep() {
        return this.selection.selected.length === 0;
    }

    //#endregion


    validMessage() {

        if (!this.selectedSender) {
            return true;
        } else {
            if (this.message) {
                return this.message.length === 0;
            } else {
                return true;
            }
        }
    }

    notifyParentsCheckChange() {
        this.notifyParents = !this.notifyParents;
    }

    close() {
        this.dialog.close();
    }


    public onFileInput($event: any) {
      for (const file of $event.target.files) {
        const index = this.files.findIndex(f => {
          return f.name === file.name && f.size === file.size;
        });
        if (index === -1) {
          if (this.files.length + 1 <= 5 && this.fileLimit(file.size)) {
            this.files.push(file);
            this.showAttachmentLimit = false;
          } else {
            this.showAttachmentLimit = true;
          }
        }
      }
    }

    private fileLimit(fileSize: number): boolean {
      const LIMIT = 25 * 1000 * 1000;
      const size = this.files.reduce((acc, file) => {
        return acc + file.size;
      }, 0);
      return (size + fileSize) < LIMIT;
    }

    async testEmailSend() {
        this.emailSendLoading = true;
        const style = `<style>table,tr,th,td {border: 1px solid black;}</style>`;

        let attachmentId = null;
        if (this.files.length > 0) {
          attachmentId = await this.uploadFiles(this.files);
        }

        const sendObject = {
          sender: {
            address: this.selectedSender.address,
            name: this.selectedSender.name
          },
          subject: this.subject,
          message: `${style}${this.message}`,
          attachmentId
        };

        try {
            this.commonService.insertItem('people/parents/notifications/testEmail', sendObject);
          // this.toastMessagesService.toastMessages(`Η αποστολή ολοκληρώθηκε με επιτυχία`);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.emailSendLoading = false;
        }
    }

    updateMessage($event: any) {
        this.message = $event;
    }

  removeFile(index: number) {
    this.files.splice(index, 1);
    this.showAttachmentLimit = false;
  }
}
